import type { Action, GenericDisplayOptions } from "../actions.types";
import { ACTION_STATUS } from "../actions.constants";

/**
 * Check if an action should be visible on the dashboard.
 * Visibility is governed by display_options:
 * - hide_from_dashboard hides the action everywhere
 * - hide_from_dashboard_when_completed hides it once completed
 * Phase placement is the caller's concern; phase-agnostic actions
 * (program_phase=null) are visible and shown in every phase.
 */
export function isActionVisibleOnDashboard(action: Action): boolean {
  const opts = action.display_options as GenericDisplayOptions | null;

  if (opts?.hide_from_dashboard === true) {
    return false;
  }

  if (
    opts?.hide_from_dashboard_when_completed === true &&
    action.current_status?.name === ACTION_STATUS.COMPLETED
  ) {
    return false;
  }

  return true;
}
